import { render, staticRenderFns } from "./MJGS.vue?vue&type=template&id=0732b2ce&scoped=true&"
import script from "./MJGS.vue?vue&type=script&lang=js&"
export * from "./MJGS.vue?vue&type=script&lang=js&"
import style0 from "./MJGS.vue?vue&type=style&index=0&id=0732b2ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0732b2ce",
  null
  
)

export default component.exports